import React, { useState, useMemo } from "react";
import { base_url } from "../../Api/Api";
import { Scrollbar } from "react-scrollbars-custom";
import ItemNotification from "./ItemNotification";
import { Link } from "react-router-dom";

const NotificationList = (props) => {
  const [state, setState] = useState({
    data: [],
    statusError: true,
  });

  useMemo(() => {

    base_url
      .get("notification_list")
      .then((response) => {
        setState({
          ...state,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response != undefined) {
          if (error.response.status == 401) {
            props.history.push(`/Entrance`);
          }
          setState({
            ...state,
            statusError: false,
          });
        }
      });
  }, []);

  return (
    <div className="box-notif" onClick={props.closePopup}>
      <Scrollbar
        style={{ width: 100 + "%", height: state.data.length <= 2 ? 250 : 330 }}
      >
        <div className="dropdown-notification">
          {state.data.length == 0 && state.statusError ? (
            <span className="no-content">
              <i className="icon-alarm"></i>
              موردی برای نمایش وجود ندارد.
            </span>
          ) : (
            state.data.map((info, index) => (
              <ItemNotification key={index} data={info} />
            ))
          )}
        </div>
      </Scrollbar>
      <div className="more-btn">
        <Link to="/Notifications">مشاهده همه</Link>
      </div>
    </div>
  );
};

export default NotificationList;
